import { createSlice } from '@reduxjs/toolkit';
import { FEATURE_NAME } from './constants';
import { GlobalSliceState } from 'src/types/types';

const initialState: GlobalSliceState = {
  reloading: false,
};

export const globalSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    reloading: (state) => {
      state.reloading = true;
    },
    reloadingEnd: (state) => {
      state.reloading = false;
    },
  },
});

export const globalReloadingAction = globalSlice.actions.reloading;
export const globalReloadingEndAction = globalSlice.actions.reloadingEnd;
